import React from "react";
import { Button } from "@material-ui/core";

const DeleteFlagModal = ({ handleClose, handleApply, bookmark }) => {
  return (
    <React.Fragment>
      <div className="flags-modal-header">Delete bookmark</div>
      <div className="flags-modal-content">
        <div className="mt-1r">
          Do you really want to delete `{bookmark || "chosen"}` bookmark?
        </div>
        <div className="mt-2r">
          <Button
            onClick={handleApply}
            variant="contained"
            color="secondary"
            className="mr-1r"
            style={{
              backgroundColor: "#de3c4b",
            }}
          >
            Delete
          </Button>
          <Button onClick={handleClose} color="primary" variant="outlined">
            Cancel
          </Button>
        </div>
      </div>
    </React.Fragment>
  );
};

export default DeleteFlagModal;
